import { render } from "./RecaptchaEditorCmp.vue?vue&type=template&id=5be25f27"
import script from "./RecaptchaEditorCmp.vue?vue&type=script&lang=js"
export * from "./RecaptchaEditorCmp.vue?vue&type=script&lang=js"

import "./RecaptchaEditorCmp.vue?vue&type=style&index=0&id=5be25f27&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__